import { render, staticRenderFns } from "./CheckBox.vue?vue&type=template&id=771fe397&"
import script from "./CheckBox.vue?vue&type=script&lang=ts&"
export * from "./CheckBox.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports